import React from "react"
import { Grid2 } from "@mui/material"

import { FooterProps } from "@/components/Dialog/protocols"

export const Footer = ({
	children
}: FooterProps) => {
	return (
		<Grid2 size={12}>
			<Grid2
				container
				justifyContent="flex-end"
				alignItems="center"
				spacing={2}
			>
				{children}
			</Grid2>
		</Grid2>
	)
}